{
  "columnResizer": "Redimensionnement de colonne",
  "loading": "Chargement...",
  "loadingMore": "Chargement supplémentaire...",
  "resizeColumn": "Redimensionner la colonne",
  "sortAscending": "Trier par ordre croissant",
  "sortDescending": "Trier par ordre décroissant"
}
